<style lang="sass">

    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    .paragraph-seemore

        &__title
            margin-top: 2rem

        &__link
            display: block
            border-left: 5px solid $color-base
            padding: 0.25rem 0.7rem
            margin: 1rem 0
            font-weight: bold
            font-family: Montserrat, sans-serif
            .page-type-product_sante &
                border-left: 5px solid $color-blue
            a
                &:after
                    display: inline-block
                    content: ''
                    width: 1rem
                    height: 1rem
                    background: url(../../common/graphics/arrow-right.svg) no-repeat
                    background-size: 0.75rem
                    background-position: center
                    vertical-align: middle
                    margin-left: 0.4rem
                    margin-top: -1px
                    transition: margin-left .15s ease
                &:hover:after
                    margin-left: 0.55rem

        &__buttons
            display: flex
            margin-top: 2rem
            +media("<=850px")
                margin-top: 2rem
                flex-direction: column

            .button
                width: auto
                +media("<=850px")
                    margin-bottom: 1rem
                    // font-size: 1rem
                    margin-right: 0

    .paragraph-product-title
        .paragraph-product-benefits__seemore
            .paragraph-seemore__buttons
                margin-top: auto
        .text
            margin-top: 0
</style>


<script>

    import $ from 'jquery'
    // import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    export default {

        mounted: function() {
            if ( $('.page-type-product_sante').length > 0 ) {
                $( ".button--red" ).addClass( "button--blue" );
                $( ".button--red" ).removeClass( "button--red" );
            }
        }
    }

</script>
